document.querySelectorAll('.product-card-swiper').forEach((gallery) => {
  const productId = gallery.getAttribute('data-product-id');
  new Swiper(`.product-card-gallery-${productId}`, {
    pagination: {
      el: `.product-card-gallery-${productId} .swiper-pagination`,
      clickable: true
    },
  });
});


function initializeSwipers() {
  document.querySelectorAll('.product-card-swiper').forEach((gallery) => {
    const productId = gallery.getAttribute('data-product-id');
    new Swiper(`.product-card-gallery-${productId}`, {
      pagination: {
        el: `.product-card-gallery-${productId} .swiper-pagination`,
        clickable: true
      },
    });
  });
}